<script lang="ts">
  import { Coffee } from "phosphor-svelte";

  export let achieved: boolean = false;
</script>

<div class="achievement" class:earned={achieved}>
  <div class="circle">
    <Coffee size="1rem" />
    {#if achieved}
      <div class="check">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
          ><rect width="256" height="256" fill="none" /><polyline
            points="40 144 96 200 224 72"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="25"
          /></svg
        >
      </div>
    {/if}
  </div>
  <div class="title">Mug Club</div>
</div>

<style>
  .achievement {
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  .title {
    font-size: 0.8rem;
    color: var(--title);
  }
  .achievement .circle {
    font-size: 1rem;
    font-weight: bold;
    background: white;
    color: var(--comment_accent);
    border: 2px solid var(--dots);
    border-radius: 50%;
    width: 2rem;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .check {
    position: absolute;
    bottom: -0.3rem;
    right: -0.5rem;
    background: var(--secondary);
    color: white;
    font-size: 0.6rem;
    border: 2px solid var(--dots);
    border-radius: 0.25rem;
    padding: 0.1rem 0.2rem 0.2rem 0.2rem;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check svg {
    width: 0.65rem;
    height: 0.65rem;
  }
  .achievement.earned .circle {
    background: var(--dots);
    color: var(--offDark);
    border: 2px solid var(--comment_accent);
  }
</style>
